module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="actions">\n    <button class="button import">Import</button>\n    <button class="button button-secondary abandon clear-import">\n        Clear Pending Import\n        \n    </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/actions.html
// module id = 211
// module chunks = 0